import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/svg/breadcrumbs-arrow/breadcrumbs-arrow.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/terms/terms.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedIcon","ColumnsIcon","ButtonIcon","SingleImage","ImagesGrid","QuoteIcon","BadgeIcon","LandingPage"] */ "/app/src/components/v1/page-style/admin/editor-console/content/widget/widget.style.ts");
;
import(/* webpackMode: "eager", webpackExports: ["UIStyledWrapper","UIStyledInner"] */ "/app/src/components/v1/ui/sectionContainer/sectionContainer.style.ts");
;
import(/* webpackMode: "eager" */ "/app/src/components/v2/atoms/bredcrumbs/breadcrumbs.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/unique/article/blocks/columns/columns.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/unique/article/blocks/content/content.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/variables.module.css");
